export default __webpack_public_path__ + "static/media/iplex 1.6 ratio.779eec2d.png";